import permission from './permission';
import Vue from 'vue';
Vue.directive('permission', permission);